import { createResponse } from './create'
import { resourceObject } from './resourceObject'

export const workflowResponse = {
  create: createResponse,
  resourceObject,
}
